import { Injectable } from '@angular/core';
import {
  AbstractGraphNodeBuilder,
  DeclarativeFieldComponent,
  FieldNodeInputDefinitionList,
  GraphBuilderContext,
} from '@fmnts/declarative-forms';
import {
  FormFieldSource,
  FormNodeName,
  FormOperatorName,
  RxJsOperatorNodeName,
} from '@fmnts/declarative-forms/common';
import {
  NextFieldKey,
  NextFieldsetKey,
  nextFieldPath,
} from '../next-form-known-fields';

const contactDataConfField: FormFieldSource = {
  name: FormNodeName.FieldValue,
  options: {
    path: nextFieldPath.contactDataOptIn,
  },
};

const fakeEmailDefinition: FieldNodeInputDefinitionList = {
  value: {
    ...contactDataConfField,
    pipe: [
      {
        operator: RxJsOperatorNodeName.FilterByCondition,
        args: [{ equals: 0, typeSafe: false }],
      },
      { operator: RxJsOperatorNodeName.MapTo, args: [null] },
      {
        operator: FormOperatorName.SetUiState,
        args: [{ pristine: true, untouched: true }],
      },
    ],
  },
  isReadonly: {
    ...contactDataConfField,
    pipe: [
      {
        operator: RxJsOperatorNodeName.MapToCondition,
        args: [{ equals: 0, typeSafe: false }],
      },
    ],
  },
};

/**
 * Builder for email field related graph nodes
 */
@Injectable({
  providedIn: 'root',
})
export class EmailFieldGraphNodeBuilder extends AbstractGraphNodeBuilder<
  string,
  string
> {
  createFakeDefinitions(ctx: GraphBuilderContext) {
    const genericComponent = ctx.injector.get(DeclarativeFieldComponent, null);

    if (NextFieldsetKey.ContactInfo === genericComponent?.fieldset.key) {
      const key = genericComponent.field.key;
      switch (key) {
        case NextFieldKey.Email:
          if (
            genericComponent.declaration.get(contactDataConfField.options.path)
          ) {
            return fakeEmailDefinition;
          }
      }
    }
  }
}
